export default "__VITE_ASSET__DJjzwaNi__"